import * as CloseIcon from './components/CloseIcon.css';
export default {
    CloseIcon
};
